<template>
  <div class="vmp-insert-video">
    <vh-dialog
      :title="$t('host.k_544001')"
      :visible.sync="insertVideoVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="850px"
    >
      <div class="vmp-insert-video-wrap">
        <div v-if="noVideo == 1">
          <div class="vmp-insert-video-wrap-search">
            <vh-button type="primary" round @click="selectLocalVideo">
              {{ $t('host.k_544002') }}
            </vh-button>
            <vh-tooltip placement="right">
              <div slot="content">
                {{ $t('host.k_544003') }}
                <br />
                {{ $t('host.k_544004') }}
                <br />
                {{ $t('host.k_544005') }}
                <br />
                {{ $t('host.k_544006') }}
              </div>
              <i class="vh-iconfont vh-line-question"></i>
            </vh-tooltip>

            <vh-input
              v-model="searchKey"
              :placeholder="$t('host.k_544007')"
              style="width: 220px; float: right"
              @keyup.enter.native="
                getTableList({
                  isNeedResetPage: true
                })
              "
              @clear="
                getTableList({
                  isNeedResetPage: true
                })
              "
              clearable
            >
              <i
                slot="prefix"
                class="vh-icon-search vh-input__icon"
                style="cursor: pointer; line-height: 36px"
                @click="
                  getTableList({
                    isNeedResetPage: true
                  })
                "
              ></i>
            </vh-input>
            <!--   <vh-select
            v-model="curInsertPlayType"
            style="width: 120px; float: right; margin-right: 10px"
            round
            placeholder="请选择"
          >
            <vh-option label="单视频播放" :value="1"></vh-option>
            <vh-option label="顺序播放" :value="2"></vh-option>
            <vh-option label="循环播放" :value="3"></vh-option>
          </vh-select> -->
          </div>
          <div class="vmp-insert-video-wrap-list">
            <ul>
              <li class="insert-list-header">
                <p class="insert-header-item0"></p>
                <p class="insert-header-item sort">
                  {{ $t('host.k_544008') }}
                  <vh-tooltip effect="dark" placement="top-start">
                    <div slot="content">{{ $t('host.k_544009') }}</div>
                    <i class="iconfont-v3 saasicon_help_m icon__max_show"></i>
                  </vh-tooltip>
                </p>
                <p class="insert-header-item insert-header-item1">{{ $t('host.k_544010') }}</p>
                <p class="insert-header-item">{{ $t('host.k_544011') }}</p>
                <p class="insert-header-item duration">{{ $t('host.k_544012') }}</p>
                <p class="insert-header-item status">{{ $t('host.k_544013') }}</p>
                <p class="insert-header-item">{{ $t('host.k_544014') }}</p>
              </li>
              <div
                class="insert-list-container"
                v-infinite-scroll="moreLoadData"
                :infinite-scroll-disabled="isFetching"
                v-show="total"
              >
                <li v-for="video in tableData" :key="video.id">
                  <p class="insert-header-item0">
                    <img
                      src="./img/playing.gif"
                      alt=""
                      v-if="currentRemoteInsertFile.id == video.id"
                    />
                  </p>
                  <p class="insert-header-item sort">
                    <vh-input
                      class="sortBox"
                      v-model.number="video.sort"
                      :maxlength="4"
                      oninput="this.value=this.value.replace(/[^\d]/g, '')"
                      @keyup.enter.native="updateOrder(video)"
                      @blur="updateOrder(video)"
                    ></vh-input>
                  </p>
                  <p class="insert-header-item">
                    <i
                      class="vh-iconfont vh-fill-audio"
                      v-if="video.file_type == '.mp3' || video.file_type == '.mav'"
                    ></i>
                    <i class="vh-iconfont vh-fill-video" v-else></i>
                    <span>{{ video.name }}</span>
                  </p>
                  <p class="insert-header-item">{{ video.created_at }}</p>
                  <p class="insert-header-item duration">{{ video.duration }}</p>
                  <p class="insert-header-item status">
                    <i
                      class="insert-process-icon"
                      :class="video.transcode_status == 1 ? 'success' : 'failer'"
                    ></i>
                    {{ video.transcode_status_text }}
                  </p>
                  <p class="insert-header-item">
                    <span class="insert-header-item-button" @click="handlePlay(video, {}, 0)">
                      {{ $t('host.k_544015') }}
                    </span>
                    <span
                      :class="video.transcode_status != 1 ? 'disable' : ''"
                      class="insert-header-item-button"
                      @click="handlePreview(video)"
                    >
                      {{ $t('host.k_544016') }}
                    </span>
                    <span class="insert-header-item-button" @click="handleDelete(video)">
                      {{ $t('host.k_544017') }}
                    </span>
                  </p>
                </li>
              </div>
              <div class="insert-list-uncontainer" v-show="!total">
                <span><img src="./img/no-search.png" alt="" /></span>
                <p>{{ $t('host.k_544018') }}</p>
              </div>
            </ul>
          </div>
        </div>
        <div class="vmp-insert-video-wrap-null" v-else>
          <img src="./img/no-create.png" alt="" />
          <p class="vmp-insert-video-wrap-null-text">{{ $t('host.k_544019') }}</p>
          <vh-button type="primary" round @click="selectLocalVideo">
            {{ $t('host.k_544002') }}
          </vh-button>
          <div>
            {{ $t('host.k_544003') }}
            <br />
            {{ $t('host.k_544004') }}
            <br />
            <span v-if="!hideItem">
              {{ $t('host.k_544005') }}
              <br />
              {{ $t('host.k_544006') }}
            </span>
          </div>
        </div>
      </div>
    </vh-dialog>
    <!-- 预览功能 -->
    <template v-if="previewDialog">
      <vh-dialog
        class="vmp-insert-video-preview"
        :visible.sync="previewDialog"
        width="642px"
        :before-close="closeBefore"
        :close-on-click-modal="true"
        :append-to-body="true"
      >
        <video-preview
          ref="videoPreview"
          :isShowController="true"
          :videoParam="videoParam"
        ></video-preview>
      </vh-dialog>
    </template>
  </div>
</template>
<script>
  import { useInsertFileServer, useMsgServer, useRoomBaseServer } from 'middle-domain';
  import videoPreview from '@/app-shared/components/video-preview';
  import { boxEventOpitons } from '@/app-shared/utils/tool.js';
  import { debounce } from 'lodash';
  export default {
    name: 'VmpInsertVideoList',
    data() {
      return {
        insertVideoVisible: false, // 弹窗显示隐藏
        searchKey: '', // 关键字搜索
        noVideo: 1, // 是否没有插播文件
        isFetching: false, // 接口加载中
        videoParam: {}, //预览数据
        tableData: [], // 插播文件列表
        pageInfo: {
          pos: 0,
          limit: 100,
          pageNum: 1
        },
        total: 1, // 总数
        totalPages: 0, // 总页数
        previewDialog: false, // 预览弹窗
        curInsertPlayType: 1, //默认单视频播放  已废弃
        playVideoList: [] //播放列表
      };
    },
    computed: {
      // 当前插播中的云插播文件
      currentRemoteInsertFile() {
        return this.$domainStore.state.insertFileServer.currentRemoteInsertFile;
      },
      // 权限配置
      configList() {
        return this.$domainStore.state.roomBaseServer.configList;
      },
      // 隐藏部分文案及选项(安利定制)
      hideItem() {
        return (
          this.configList['initiate_embed_function_close'] &&
          (this.$route.query.liveT ||
            this.$route.query.live_token ||
            this.$route.query.assistant_token)
        );
      },
      // 是否开启了桌面共享
      isShareScreen() {
        return this.$domainStore.state.desktopShareServer.localDesktopStreamId;
      },
      // 桌面共享人信息
      desktopShareInfo() {
        return this.$domainStore.state.desktopShareServer.desktopShareInfo;
      },
      // 是否工具简单模式（乐乐专属）
      isLeLeInteractMode() {
        return this.$domainStore.state.roomBaseServer?.configList?.['lele_interact_model'];
      },
      // 是否直播带货模式
      isLiveCommerceMode() {
        return this.$domainStore.state.roomBaseServer?.configList?.['live_commerce_model'];
      }
    },
    components: {
      videoPreview
    },
    beforeCreate() {
      this.insertFileServer = useInsertFileServer();
      this.msgServer = useMsgServer();
    },
    created() {
      this.assistantType = this.$route.query.assistantType;
    },
    mounted() {
      this.openInsertFileDialog(true);
    },
    methods: {
      // 显示插播列表 dialog
      openInsertFileDialog(loadInsertCache = false) {
        // 检查是否可以插播文件
        window.vhallReportForProduct.toStartReporting(110189, [110190, 110191]);
        const isCanInsert = this.checkInsertFileProcess();
        window.vhallReportForProduct.toResultsReporting(110190, {
          event_type: 'static',
          isCanInsert
        });
        if (isCanInsert) {
          if (!loadInsertCache) {
            // 显示插播列表
            this.insertVideoVisible = true;
          }

          window.vhallReportForProduct.toResultsReporting(110191, {
            event_type: 'static'
          });
          this.getTableList({
            isNeedResetPage: true,
            isInvokeInCreated: true,
            loadInsertCache
          });
        }
      },

      // 检测当前用户是否可以插播
      checkInsertFileProcess() {
        if (this.isLeLeInteractMode || this.isLiveCommerceMode) return false;
        const insertFileServer = useInsertFileServer();
        const { watchInitData } = useRoomBaseServer().state;
        const { isInsertFilePushing, insertStreamInfo } = insertFileServer.state;
        console.log('---点击插播文件按钮----', insertStreamInfo);

        // 如果是直播状态需要判断当前主持人是否是用网页发起直播
        // 嘉宾：设为主讲人的时候 可以插播
        // 助理： 如果是网页发起，一直都有插播。如果是客户端发起，不支持插播文件，存在提示
        if (
          watchInitData.switch.start_type != 1 &&
          watchInitData.webinar.type == 1 &&
          watchInitData.join_info.role_name == 3
        ) {
          this.$vhAlert(this.$t('host.k_544020'), '', {
            title: this.$t('host.k_544021'),
            confirmButtonText: this.$t('host.k_544022'),
            roundButton: true
          });
          return false;
        }

        // 如果在插播中，并且不是当前用户插播，alert提示
        if (
          isInsertFilePushing &&
          insertStreamInfo.userInfo.accountId != watchInitData.join_info.third_party_user_id
        ) {
          this.$vhAlert(
            this.$t('host.k_544023', [
              this.$getRoleName(insertStreamInfo.userInfo.role),
              insertStreamInfo.userInfo.role != 1 ? insertStreamInfo.userInfo.nickname : ''
            ]),

            '',
            {
              title: this.$t('host.k_544021'),
              confirmButtonText: this.$t('host.k_544024'),
              roundButton: true
            }
          );
          return false;
        }

        // 判断该当前浏览器是否支持插播
        if (!insertFileServer.isCanUseCaptureStream()) {
          this.$vhAlert(
            this.$t('host.k_544025'),

            '',
            {
              title: this.$t('host.k_544021'),
              confirmButtonText: this.$t('host.k_544022'),
              dangerouslyUseHTMLString: true,
              roundButton: true,
              callback: () => {}
            }
          );
          return false;
        }
        return true;
      },
      // 关闭插播列表弹窗
      closeInserVideoDialog() {
        this.insertVideoVisible = false;
      },
      // 选择本地文件插播
      selectLocalVideo() {
        window.vhallReportForProduct?.toReport(110216);
        // 他人正在演示插播，当前不可操作；有人正在桌面共享，当前不可插播
        if (!this.checkInsertFileProcess() || this.isShareScreen) {
          if (this.isShareScreen && this.desktopShareInfo) {
            // 当前有桌面共享，并且桌面共享演示人信息能获取的时候
            this.$vhAlert(
              this.$t('host.k_544026', [
                this.$getRoleName(this.desktopShareInfo.role),
                this.desktopShareInfo.role != 1 ? this.desktopShareInfo.nickname : ''
              ]),

              '',
              {
                title: this.$t('host.k_544021'),
                confirmButtonText: this.$t('host.k_544024'),
                roundButton: true
              }
            );
          }
          // 当前不可演示插播, 关闭插播列表弹窗
          this.closeInserVideoDialog();
          return;
        }
        const insertFileServer = useInsertFileServer();
        const { watchInitData } = useRoomBaseServer().state;
        const _this = this;
        insertFileServer.selectLocalFile(e => {
          // 如果是音频直播
          if (watchInitData.webinar.mode == 1) {
            const video_ext_type = e.target.files[0].type; // type: "audio/ogg" // video/mp4
            if (!(video_ext_type.includes('ogg') || video_ext_type.includes('mpeg'))) {
              _this.$message.warning(this.$t('host.k_544027'));
              return;
            }
          } else {
            const video_ext_type = e.target.files[0].type; // type: "audio/ogg" // video/mp4  audio/mpeg
            if (
              !(
                video_ext_type.includes('ogg') ||
                video_ext_type.includes('mp4') ||
                video_ext_type.includes('mpeg') ||
                video_ext_type.includes('webm')
              )
            ) {
              _this.$message.warning(this.$t('host.k_544028'));
              return;
            }
            console.log('本地插播上传的文件', e, e.target.files[0]);
            this.initLocalVideo(e.target.files[0]);
          }
        });
      },
      // 进入本地文件插播
      initLocalVideo(File) {
        console.log('本地插播上传的文件', File);
        const isGt5M = File.size / 1024 / 1024 / 1024 > 5;
        console.log(File.type, 'File.type');
        if (isGt5M) {
          this.$message.warning(this.$t('host.k_544029'));
          return;
        }
        window.vhallReportForProduct?.toReport(110217);
        window.$middleEventSdk?.event?.send(
          boxEventOpitons(this.cuid, 'emitInsertFileChange', [File, 'local'])
        );
      },
      moreLoadData() {
        if (this.pageInfo.pageNum >= this.totalPages) {
          return false;
        }
        this.pageInfo.pageNum++;
        this.isFetching = true;
        this.pageInfo.pos = parseInt((this.pageInfo.pageNum - 1) * this.pageInfo.limit);
        this.getTableList({
          isNeedResetPage: false
        });
      },
      getTableList: debounce(function (
        options = {
          isNeedResetPage: false,
          isInvokeInCreated: false,
          loadInsertCache: false
        }
      ) {
        const { watchInitData } = useRoomBaseServer().state;
        if (options.isNeedResetPage) {
          this.pageInfo = {
            pos: 0,
            limit: 100,
            pageNum: 1
          };
          this.tableData = [];
        }
        const params = {
          name: this.searchKey,
          get_no_trans: 1,
          webinar_id: watchInitData.webinar.id,
          ...this.pageInfo
        };
        this.insertFileServer.getInsertFileList(params).then(res => {
          if (res.code == 200) {
            // 转码状态:0新增排队中 1转码成功 2转码失败 3转码中
            res.data.list.forEach(ele => {
              ele.sort_origin = ele.sort;
              ele.file_type = ele.file_type.toLowerCase();
              switch (ele.transcode_status) {
                case 0:
                  ele.transcode_status_text = this.$t('host.k_544030');
                  ele.duration = '——';
                  break;
                case 1:
                  ele.transcode_status_text = this.$t('host.k_544031');
                  break;
                case 2:
                  ele.transcode_status_text = this.$t('host.k_544032');
                  ele.duration = '——';
                  break;
                case 3:
                  ele.transcode_status_text = this.$t('host.k_544030');
                  ele.duration = '——';
                  break;
                default:
                  ele.transcode_status_text = this.$t('host.k_544030');
                  ele.duration = '——';
                  break;
              }
            });
            if (!this.searchKey) {
              this.playVideoList = this.tableData;
            }
            this.isFetching = false;
            this.tableData.push(...res.data.list);
            this.total = res.data.total;
            this.totalPages = Math.ceil(res.data.total / this.pageInfo.limit);
            if (options.isInvokeInCreated) {
              this.noVideo = !res.data.total ? 2 : 1;
            }
          }
          // const { watchInitData } = useRoomBaseServer().state;
          if (options.loadInsertCache) {
            // 直播中 读取 缓存
            this.loadInsertCache();
          }
        });
      }, 500),
      // 云插播开始播放
      handlePlay(video, params = {}, insertPlayType = 0) {
        window.vhallReportForProduct?.toReport(110197, { report_extra: { file_info: video } });
        const insertFileServer = useInsertFileServer();
        const insertFileServerState = insertFileServer.state;
        const { watchInitData } = useRoomBaseServer().state;
        let isAudioFile = false;
        const videoType = video.file_type;
        if (
          videoType.toLowerCase() === '.ogg' ||
          videoType.toLowerCase() === '.mp3' ||
          videoType.toLowerCase() === '.mav'
        ) {
          isAudioFile = true;
        }
        insertFileServerState.insertStreamInfo.has_video = !isAudioFile;

        // if (insertPlayType) {
        //   this.curInsertPlayType = insertPlayType;
        // }
        // 如果当前角色正在进行插播，需要先确认
        if (
          insertFileServerState.isInsertFilePushing &&
          insertFileServerState.insertStreamInfo.userInfo.accountId ==
            watchInitData.join_info.third_party_user_id &&
          !params.jumpCheck
        ) {
          this.$vhConfirm(this.$t('host.k_544033'), this.$t('host.k_544021'), {
            confirmButtonText: this.$t('host.k_544024'),
            cancelButtonText: this.$t('host.k_544034'),
            roundButton: true
          }).then(() => {
            window.$middleEventSdk?.event?.send(
              boxEventOpitons(this.cuid, 'emitInsertFileChange', [
                video,
                'remote',
                this.curInsertPlayType,
                params
              ])
            );
          });
        } else {
          window.$middleEventSdk?.event?.send(
            boxEventOpitons(this.cuid, 'emitInsertFileChange', [
              video,
              'remote',
              this.curInsertPlayType,
              params
            ])
          );
        }
      },
      handleDelete(video) {
        window.vhallReportForProduct.toStartReporting(110231, [110233, 110238, 110234]);
        this.$vhConfirm(this.$t('host.k_544035'), this.$t('host.k_544021'), {
          confirmButtonText: this.$t('host.k_544024'),
          cancelButtonText: this.$t('host.k_544034'),
          roundButton: true
        })
          .then(() => {
            window.vhallReportForProduct?.toResultsReporting(110233, {
              event_type: 'static'
            });
            this.insertFileServer
              .deleteInsertFile({
                ids: video.id
              })
              .then(res => {
                window.vhallReportForProduct?.toResultsReporting(110238, {
                  request_id: res?.request_id,
                  event_type: 'interface',
                  res
                });
                if (res.code === 200) {
                  this.getTableList({
                    isNeedResetPage: true
                  });
                  this.$message({
                    message: this.$t('host.k_544036'),
                    showClose: true,
                    type: 'success',
                    customClass: 'zdy-info-box'
                  });
                }
              })
              .catch(res => {
                window.vhallReportForProduct?.toResultsReporting(110234, {
                  event_type: 'static'
                });
                this.$message({
                  message: res.msg || this.$t('host.k_544037'),
                  showClose: true,
                  type: 'error',
                  customClass: 'zdy-info-box'
                });
              });
          })
          .catch(() => {});
      },
      // 预览页面
      handlePreview(video) {
        this.previewDialog = true;
        window.vhallReportForProduct.toReport(110192, { report_extra: { file_info: video } });
        if (video.transcode_status == 1) {
          this.videoParam = {
            autoplay: true,
            ...video
          };
        } else {
          this.$message.warning(this.$t('host.k_544038'));
        }
      },
      closeBefore(done) {
        this.previewDialog = false;
        this.$refs.videoPreview.destroy();
        done();
      },
      //更改顺序
      updateOrder(info) {
        this.tableData.forEach(item => {
          if (item.id == info.id) {
            if (item.sort_origin != info.sort) {
              const { watchInitData } = useRoomBaseServer().state;
              let params = {
                webinar_id: watchInitData.webinar.id,
                id: info.id,
                sort: info.sort
              };
              this.insertFileServer
                .waitingVideoSort({
                  ...params
                })
                .then(res => {
                  this.getTableList({
                    isNeedResetPage: true
                  });
                });
            }
          }
        });
      },
      loadInsertCache() {
        const { watchInitData } = useRoomBaseServer().state;
        let inserts = sessionStorage.getItem('insertCache');
        let arr = [];
        if (inserts) {
          arr = JSON.parse(inserts);
          for (let i = 0; i < arr.length; i++) {
            const element = arr[i];
            if (element.webinar_id == watchInitData.webinar.id) {
              for (let j = 0; j < this.tableData.length; j++) {
                const element2 = this.tableData[j];
                if (element2.paas_record_id == element.paas_record_id) {
                  if (watchInitData.webinar.type == 1) {
                    //直播中则使用  否则删除
                    //列表中存在该活动上次缓存的同一个视频文件
                    this.$nextTick(() => {
                      this.handlePlay(element2, {
                        jumpCheck: true,
                        ...element
                      });
                      return;
                    });
                  } else {
                    arr.splice(i, 1);
                    break;
                  }
                }
              }
            }
          }
          sessionStorage.setItem('insertCache', JSON.stringify(arr));
        }
      },
      onInsertVideoEnd(params) {
        //insertPlayType
        console.log('插播视频播放结束', params);
        // this.curInsertPlayType = params.insertPlayType;
        if (params.insertPlayType == 1) {
          //单视频播放
        } else if (params.insertPlayType == 2) {
          //顺序播放
          if (this.currentRemoteInsertFile) {
            //非本地播放
            for (let index = 0; index < this.playVideoList.length; index++) {
              const element = this.playVideoList[index];
              if (this.currentRemoteInsertFile.id == element.id) {
                if (this.playVideoList.length - 1 != index) {
                  // this.curInsertPlayType = 2;
                  this.handlePlay(this.playVideoList[index + 1], {
                    jumpCheck: true
                  });
                }
                break;
              }
            }
          }
        } else if (params.insertPlayType == 3) {
          //单视频循环播放
        }
      }
      // changeInsertVideoType(val) {
      //   this.curInsertPlayType = val;
      // }
    }
  };
</script>
<style lang="less">
  .vmp-insert-video {
    &-wrap {
      &-search {
        overflow: hidden;
        .vh-line-question {
          margin-left: 10px;
          color: #999;
        }
        .vh-input__inner {
          border-radius: 20px;
          height: 36px;
          line-height: 36px;
        }
        .vh-select .vh-input__inner {
          height: 36px;
          line-height: 36px;
        }
      }
      &-list {
        width: 100%;
        margin-top: 16px;
        ul {
          list-style: none;
          li {
            display: flex;
            height: 56px;
            line-height: 56px;
            color: #1a1a1a;
            &.insert-list-header {
              background-color: #f7f7f7;
              color: #666;
            }
            .insert-header-item0 {
              width: 60px;
              text-align: center;
              img {
                width: 12px;
                height: 12px;
              }
            }
            .insert-header-item {
              width: 200px;
              &.sort {
                width: 100px;
              }
              .sortBox {
                width: 60px;
                input {
                  height: 30px;
                }
              }
              &.duration,
              &.status {
                width: 120px;
              }
            }
            .insert-header-item {
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
          .insert-list-container {
            overflow-y: auto;
            height: 336px;
            li {
              border-bottom: 1px solid #e6e6e6;
              .insert-header-item {
                .vh-iconfont {
                  margin-right: 14px;
                  font-size: 18px;
                }
                .vh-fill-video {
                  color: #ff733c;
                }
                .vh-fill-audio {
                  color: #10d3a8;
                }
                .insert-process-icon {
                  display: inline-block;
                  width: 8px;
                  height: 8px;
                  border-radius: 4px;
                  margin-right: 6px;
                  &.success {
                    background-color: #14ba6a;
                  }
                  &.failer {
                    background-color: #fb3a32;
                  }
                }
                &-button {
                  margin-right: 10px;
                  color: #666;
                  &.disable {
                    color: #666;
                    pointer-events: none;
                  }
                }
              }
              &:hover {
                background-color: #f7f7f7;
                .insert-header-item-button {
                  color: #fb3a32;
                  cursor: pointer;
                }
              }
            }
          }
          .insert-list-uncontainer {
            padding: 80px 0 140px;
            margin: 0 auto;
            text-align: center;
            p {
              line-height: 40px;
              color: #666;
            }
          }
        }
      }
      &-null {
        padding: 50px 0 100px;
        text-align: center;
        &-text {
          margin: 15px 0;
          color: #666;
          line-height: 20px;
          font-size: 14px;
        }
        .vh-button.is-round {
          // padding: 7px 47px;
        }
        div {
          width: 524px;
          margin-top: 24px;
          font-size: 12px;
          line-height: 17px;
          color: #999;
          word-break: break-word;
          overflow-wrap: break-word;
          word-break: normal;
          text-align: left;
          margin-left: 102px;
        }
      }
    }
    &-preview {
      .vh-dialog {
        background: transparent;
        box-shadow: none;
      }
      .vh-dialog__header {
        width: 642px !important;
        padding: 0;
        height: 55px;
        background: transparent !important;
        border: none;
        color: #fff;
      }
      .vh-dialog__body {
        height: 361px;
        border-top: 4px solid #000;
        border-bottom: 4px solid #000;
        background: #000;
        border-radius: 4px;
        padding: 0 4px;
      }
      .vh-dialog__headerbtn {
        right: 10px;
        .vh-dialog__close {
          color: #fff;
          &:hover {
            color: #fff;
          }
        }
        &-null {
          padding: 50px 0 100px 0;
          text-align: center;
          &-text {
            margin: 15px 0;
            color: #666;
            line-height: 20px;
            font-size: 14px;
          }
          .vh-button.is-round {
            padding: 7px 47px;
          }
          div {
            width: 524px;
            margin-top: 24px;
            font-size: 12px;
            line-height: 17px;
            color: #999;
            word-break: break-all;
            text-align: left;
            margin-left: 102px;
          }
        }
      }
    }
    &-preview {
      .vh-dialog {
        background: transparent;
        box-shadow: none;
      }
      .vh-dialog__header {
        width: 642px !important;
        padding: 0;
        height: 55px;
        background: transparent !important;
        border: none;
        color: #fff;
      }
      .vh-dialog__body {
        height: 361px;
        border-top: 4px solid #000;
        border-bottom: 4px solid #000;
        background: #000;
        border-radius: 4px;
        padding: 0 4px;
      }
      .vh-dialog__headerbtn {
        right: 10px;
        .vh-dialog__close {
          color: #fff;
          &:hover {
            color: #fff;
          }
        }
      }
    }
  }
</style>
